import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { verifyEmail } from '../api/userApi';

const VerifyEmail = () => {

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const [message, setMessage] = useState('Vérification en cours...');
    const [success, setSuccess] = useState(false);

    useEffect(() => {

        const token = searchParams.get('token');

        if (!token) {
            setMessage('Token invalide');
            return;
        }

        verifyEmail(token)
            .then(() => {
                setSuccess(true);
                setMessage('Votre compte a été activé avec succès.');
            })
            .catch(() => {
                setMessage('Lien invalide ou expiré.');
            });

    }, [searchParams]);

    return (
        <div className="container mt-5 text-center">
            <h2>Vérification du compte</h2>

            <p>{message}</p>

            {success && (
                <button
                    className="btn btn-primary"
                    onClick={() => navigate('/login')}
                >
                    Se connecter
                </button>
            )}
        </div>
    );
};

export default VerifyEmail;